import { observer } from 'mobx-react-lite';
import { Modal, ModalProps } from './modal';
import { useTranslationsContext } from 'store/translations';
import { CollectionCard } from 'components/cards/collectionCard';

interface Props extends ModalProps {
    collectionId: number;
}

export const CollectionModal = observer(({ collectionId, ...rest }: Props) => {
    const { translate } = useTranslationsContext();
    return (
        <Modal title={translate('collection.preview.title')} {...rest}>
            <div className="collection-modal">
                <CollectionCard collectionId={collectionId} isPreview />
            </div>
        </Modal>
    );
});
